import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { SortPipe } from '../util/sort.pipe';
import { NgForOf, NgIf } from '@angular/common';
import { FilterOption } from '../models';
import { ArrayIncludesPipe } from '@markant-platform/shared/util-pipes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UiCountrySelectComponent } from '@markant-platform/shared/ui-components';

@Component({
  selector: 'markant-platform-filter-country',
  templateUrl: './filter-country.component.html',
  styleUrls: ['./filter-country.component.scss'],
  imports: [
    MarkantElementsModule,
    TranslocoModule,
    SortPipe,
    NgForOf,
    NgIf,
    ArrayIncludesPipe,
    UiCountrySelectComponent,
  ],
  standalone: true,
})
export class FilterCountryComponent implements OnInit {
  @Input() id = '';
  @Input() label = '';
  @Input() options: FilterOption[] = [];
  @Input() selectedOptions: string[] = [];
  @Input() resetNotifier$ = new Subject<void>();

  @Output() filterChangeEmitter = new EventEmitter<Record<string, string[]>>();

  get visibleOptions(): FilterOption[] {
    return this.options.filter(option => this._visibleOptions.includes(option.key));
  }

  private _visibleOptions: string[] = [];

  constructor(private readonly destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.resetNotifier$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.selectedOptions = [];
      this._visibleOptions = [];
      this.filterChangeEmitter.emit({ [this.id]: [] });
    });

    this._visibleOptions = [...this.selectedOptions];
  }

  selectCountry(countryCode: string): void {
    const option = this.options.find(option => option.key === countryCode);

    if (option) {
      this.toggleOption(option);
    }
  }

  toggleOption(option: FilterOption): void {
    const index = this.selectedOptions.indexOf(option.key);
    if (index < 0) {
      this.selectedOptions.push(option.key);
      this._visibleOptions.push(option.key);
      this.selectedOptions.sort();
      this._visibleOptions.sort();
    } else {
      this.selectedOptions.splice(index, 1);
    }
    this.filterChangeEmitter.emit({ [this.id]: this.selectedOptions });
  }
}
